import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  refund: {
    amount: '',
    currency: '',
    progressDetails: [],
    uiState: UiState.Idle
  }
};

const getRefundRequest = draft => {
  draft.refund.uiState = UiState.Pending;
};

const getRefundFailure = draft => {
  draft.refund.uiState = UiState.Failure;
};

const getRefundSuccess = (draft, action) => {
  const {
    refund
  } = action.payload;
  draft.refund = _objectSpread(_objectSpread({}, refund), {}, {
    uiState: UiState.Success
  });
};

const refundSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    getRefundRequest,
    getRefundFailure,
    getRefundSuccess
  }
});
export const {
  actions
} = refundSlice;
export const plug = {
  [stateName]: refundSlice.reducer
};
export default refundSlice.reducer;